import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit{
  @Input() nombre: string = '';
  @Input() fecha: string = '';
  soloIconos = false;
  public datos: any;
  public today: any;

  ngOnInit(){}
  
           // SoloIconos welcome div.
    toggleSoloIconos() {
      this.soloIconos = !this.soloIconos;
    }

}